import React from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';
import { Card, CardContent } from '../components/ui/card';
import { Shield, Lock, Eye, Database, UserCheck } from 'lucide-react';

const DatenschutzPage = () => {
  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-50 to-blue-50">
      <Header />
      
      <section className="pt-32 pb-20">
        <div className="container mx-auto px-4 sm:px-6 lg:px-8 max-w-4xl">
          <div className="flex items-center mb-8">
            <Shield className="w-12 h-12 text-sky-600 mr-4" />
            <h1 className="text-4xl sm:text-5xl font-bold text-gray-900">
              Datenschutzerklärung
            </h1>
          </div>

          <Card className="border-0 shadow-xl mb-8">
            <CardContent className="p-8">
              <div className="space-y-8">
                <div>
                  <h2 className="text-2xl font-bold text-gray-900 mb-4">
                    1. Datenschutz auf einen Blick
                  </h2>
                  <h3 className="text-lg font-semibold text-gray-900 mb-3">Allgemeine Hinweise</h3>
                  <p className="text-gray-600 leading-relaxed mb-4">
                    Die folgenden Hinweise geben einen einfachen Überblick darüber, was mit Ihren personenbezogenen 
                    Daten passiert, wenn Sie diese Website besuchen. Personenbezogene Daten sind alle Daten, mit 
                    denen Sie persönlich identifiziert werden können.
                  </p>
                  
                  <h3 className="text-lg font-semibold text-gray-900 mb-3">Datenerfassung auf dieser Website</h3>
                  <h4 className="font-semibold text-gray-800 mb-2">
                    Wer ist verantwortlich für die Datenerfassung auf dieser Website?
                  </h4>
                  <p className="text-gray-600 leading-relaxed mb-4">
                    Die Datenverarbeitung auf dieser Website erfolgt durch den Websitebetreiber. Dessen Kontaktdaten 
                    können Sie dem Abschnitt „Hinweis zur verantwortlichen Stelle" in dieser Datenschutzerklärung entnehmen.
                  </p>
                </div>

                <div className="border-t pt-8">
                  <h2 className="text-2xl font-bold text-gray-900 mb-4">
                    2. Hosting
                  </h2>
                  <p className="text-gray-600 leading-relaxed mb-4">
                    Wir hosten die Inhalte unserer Website bei folgendem Anbieter:
                  </p>
                  <h3 className="text-lg font-semibold text-gray-900 mb-3">Externes Hosting</h3>
                  <p className="text-gray-600 leading-relaxed">
                    Diese Website wird extern gehostet. Die personenbezogenen Daten, die auf dieser Website erfasst 
                    werden, werden auf den Servern des Hosters / der Hoster gespeichert. Hierbei kann es sich v. a. 
                    um IP-Adressen, Kontaktanfragen, Meta- und Kommunikationsdaten, Vertragsdaten, Kontaktdaten, 
                    Namen, Websitezugriffe und sonstige Daten, die über eine Website generiert werden, handeln.
                  </p>
                </div>

                <div className="border-t pt-8">
                  <h2 className="text-2xl font-bold text-gray-900 mb-4">
                    3. Allgemeine Hinweise und Pflichtinformationen
                  </h2>
                  
                  <h3 className="text-lg font-semibold text-gray-900 mb-3">Datenschutz</h3>
                  <p className="text-gray-600 leading-relaxed mb-4">
                    Die Betreiber dieser Seiten nehmen den Schutz Ihrer persönlichen Daten sehr ernst. Wir behandeln 
                    Ihre personenbezogenen Daten vertraulich und entsprechend den gesetzlichen Datenschutzvorschriften 
                    sowie dieser Datenschutzerklärung.
                  </p>

                  <h3 className="text-lg font-semibold text-gray-900 mb-3">
                    Hinweis zur verantwortlichen Stelle
                  </h3>
                  <p className="text-gray-600 leading-relaxed mb-2">
                    Die verantwortliche Stelle für die Datenverarbeitung auf dieser Website ist:
                  </p>
                  <div className="bg-gray-50 p-4 rounded-lg mb-4">
                    <p className="text-gray-700">
                      Gravante Solar<br />
                      Am Wammesknopf 6<br />
                      70439 Stuttgart<br />
                      Deutschland<br /><br />
                      Telefon: +49 157 82283963<br />
                      E-Mail: Buchhaltung@gravante.de
                    </p>
                  </div>
                  <p className="text-gray-600 leading-relaxed">
                    Verantwortliche Stelle ist die natürliche oder juristische Person, die allein oder gemeinsam 
                    mit anderen über die Zwecke und Mittel der Verarbeitung von personenbezogenen Daten 
                    (z. B. Namen, E-Mail-Adressen o. Ä.) entscheidet.
                  </p>
                </div>

                <div className="border-t pt-8">
                  <h2 className="text-2xl font-bold text-gray-900 mb-4">
                    4. Datenerfassung auf dieser Website
                  </h2>
                  
                  <h3 className="text-lg font-semibold text-gray-900 mb-3">Kontaktformular</h3>
                  <p className="text-gray-600 leading-relaxed mb-4">
                    Wenn Sie uns per Kontaktformular Anfragen zukommen lassen, werden Ihre Angaben aus dem 
                    Anfrageformular inklusive der von Ihnen dort angegebenen Kontaktdaten zwecks Bearbeitung 
                    der Anfrage und für den Fall von Anschlussfragen bei uns gespeichert. Diese Daten geben 
                    wir nicht ohne Ihre Einwilligung weiter.
                  </p>
                  <p className="text-gray-600 leading-relaxed">
                    Die Verarbeitung dieser Daten erfolgt auf Grundlage von Art. 6 Abs. 1 lit. b DSGVO, sofern 
                    Ihre Anfrage mit der Erfüllung eines Vertrags zusammenhängt oder zur Durchführung vorvertraglicher 
                    Maßnahmen erforderlich ist. In allen übrigen Fällen beruht die Verarbeitung auf unserem 
                    berechtigten Interesse an der effektiven Bearbeitung der an uns gerichteten Anfragen 
                    (Art. 6 Abs. 1 lit. f DSGVO) oder auf Ihrer Einwilligung (Art. 6 Abs. 1 lit. a DSGVO) 
                    sofern diese abgefragt wurde.
                  </p>
                </div>

                <div className="border-t pt-8">
                  <h2 className="text-2xl font-bold text-gray-900 mb-4">
                    5. Ihre Rechte
                  </h2>
                  <div className="space-y-4">
                    <div className="flex items-start">
                      <UserCheck className="w-6 h-6 text-sky-600 mr-3 mt-1 flex-shrink-0" />
                      <div>
                        <h4 className="font-semibold text-gray-800 mb-1">Auskunftsrecht</h4>
                        <p className="text-gray-600 text-sm">
                          Sie haben das Recht, Auskunft über Ihre bei uns gespeicherten personenbezogenen Daten zu erhalten.
                        </p>
                      </div>
                    </div>
                    <div className="flex items-start">
                      <Lock className="w-6 h-6 text-sky-600 mr-3 mt-1 flex-shrink-0" />
                      <div>
                        <h4 className="font-semibold text-gray-800 mb-1">Berichtigung und Löschung</h4>
                        <p className="text-gray-600 text-sm">
                          Sie haben das Recht, die Berichtigung unrichtiger Daten und die Löschung Ihrer Daten zu verlangen.
                        </p>
                      </div>
                    </div>
                    <div className="flex items-start">
                      <Eye className="w-6 h-6 text-sky-600 mr-3 mt-1 flex-shrink-0" />
                      <div>
                        <h4 className="font-semibold text-gray-800 mb-1">Einschränkung der Verarbeitung</h4>
                        <p className="text-gray-600 text-sm">
                          Sie haben das Recht, die Einschränkung der Verarbeitung Ihrer personenbezogenen Daten zu verlangen.
                        </p>
                      </div>
                    </div>
                    <div className="flex items-start">
                      <Database className="w-6 h-6 text-sky-600 mr-3 mt-1 flex-shrink-0" />
                      <div>
                        <h4 className="font-semibold text-gray-800 mb-1">Datenübertragbarkeit</h4>
                        <p className="text-gray-600 text-sm">
                          Sie haben das Recht, Ihre Daten in einem strukturierten, gängigen und maschinenlesbaren Format zu erhalten.
                        </p>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="border-t pt-8">
                  <h2 className="text-2xl font-bold text-gray-900 mb-4">
                    6. Cookies
                  </h2>
                  <p className="text-gray-600 leading-relaxed mb-4">
                    Unsere Internetseiten verwenden so genannte „Cookies". Cookies sind kleine Textdateien und 
                    richten auf Ihrem Endgerät keinen Schaden an. Sie werden entweder vorübergehend für die Dauer 
                    einer Sitzung (Session-Cookies) oder dauerhaft (permanente Cookies) auf Ihrem Endgerät gespeichert.
                  </p>
                  <p className="text-gray-600 leading-relaxed">
                    Sie können Ihren Browser so einstellen, dass Sie über das Setzen von Cookies informiert werden 
                    und Cookies nur im Einzelfall erlauben, die Annahme von Cookies für bestimmte Fälle oder generell 
                    ausschließen sowie das automatische Löschen der Cookies beim Schließen des Browsers aktivieren.
                  </p>
                </div>

                <div className="border-t pt-8">
                  <h2 className="text-2xl font-bold text-gray-900 mb-4">
                    7. Kontakt bei Datenschutzfragen
                  </h2>
                  <p className="text-gray-600 leading-relaxed mb-4">
                    Bei Fragen zum Datenschutz können Sie sich jederzeit an uns wenden:
                  </p>
                  <div className="bg-sky-50 p-6 rounded-lg border border-sky-200">
                    <p className="text-gray-700">
                      <strong>Gravante Solar</strong><br />
                      Am Wammesknopf 6<br />
                      70439 Stuttgart<br /><br />
                      E-Mail: Buchhaltung@gravante.de<br />
                      Telefon: +49 157 82283963
                    </p>
                  </div>
                </div>

                <div className="border-t pt-8">
                  <p className="text-sm text-gray-500">
                    Stand: {new Date().toLocaleDateString('de-DE', { year: 'numeric', month: 'long', day: 'numeric' })}
                  </p>
                </div>
              </div>
            </CardContent>
          </Card>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default DatenschutzPage;
